import { render } from "./PriceListDialog.vue?vue&type=template&id=31b659cb&scoped=true"
import script from "./PriceListDialog.vue?vue&type=script&lang=js"
export * from "./PriceListDialog.vue?vue&type=script&lang=js"

import "./PriceListDialog.vue?vue&type=style&index=0&id=31b659cb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b659cb"]])

export default __exports__